import classNames from 'classnames';

import FacebookApps from '../facebook-apps/facebook-apps.component';
import ForbesLogoLink from '../forbes-logo-link/forbes-logo-link.component';
import ShareLinks from '../share-links/share-links.component';
import styles from './footer.module.scss';

const Footer: React.FunctionComponent = () => {
  return (
    <footer className={classNames(styles.component)}>
      <div className={classNames(styles.content)}>
        <div className={styles.left}>
          <FacebookApps />

          <a className={classNames(styles.link)} href="http://ads.adfox.ru/162070/goLink?p1=cqocf&p2=frfe&p5=kncuu&pr=[RANDOM]&puid1=&puid2=">
            Перейти на сайт Meta for Business
          </a>
        </div>

        <div className={styles.center}>
          <span>Поделиться в соцсетях</span>
          <ShareLinks />
        </div>

        <div className={styles.right}>
          <ForbesLogoLink />
        </div>
      </div>
    </footer>
  );
};


export default Footer;
